module.exports = __webpack_public_path__ + "static/media/task4Planet2.8470131f.png";